<template>
    <!-- TODO: ensure the info and user icons display correctly in every place this component is used. -->
    <div class="acceptAnyOdds">
        <span
            class="acceptAnyOdds-tip ASI_JARVIS_BetTicket_AcceptAnyOdds_Tooltip"
            v-on:click="handleClickAcceptAnyOddsTip"
        >
            <SboIcon name="system:infoCircle" v-bind:size="16" />
            <span
                v-if="showAcceptAnyOddsTip"
                class="acceptAnyOdds-tip-arrow"
            />
            <Transition name="fade-out">
                <div v-if="showAcceptAnyOddsTip" class="acceptAnyOdds-tip-content">
                    <p>{{ i18n.t('acceptAnyOdds_introduction') }}</p>
                    <p>{{ i18n.t('acceptAnyOdds_setting') }} :</p>
                    <p>
                        <SboIcon name="system:user" />
                        <span>{{ i18n.t('acceptAnyOdds_setting_location') }}</span>
                    </p>
                </div>
            </Transition>
        </span>
        <span v-on:click="handleClickAcceptAnyOddsTip">{{ i18n.t('acceptAnyOdds') }}</span>
        <span
            v-if="customerInfo.isAcceptAnyOdds"
            class="acceptAnyOdds-tick"
            v-on:click="handleClickAcceptAnyOddsTip"
        >
            <SboIcon name="system:checkOutline" v-bind:size="16" />
        </span>
        <SwitchButton
            v-else
            v-bind:class="acceptAnyOddsGaClass"
            v-bind:value="customerInfo.isAcceptAnyOdds"
            name="acceptAnyOdds"
            v-on:toggle="toggleAcceptAnyOdds"
        />
    </div>
</template>

<script setup lang="ts">
    import { storeToRefs } from 'pinia';
    import { computed, onUnmounted, ref } from 'vue';
    import SboIcon from '@/components/common/SboIcon.vue';
    import SwitchButton from '@/components/common/SwitchButton.vue';
    import { useApp } from '@/libraries/composables/useApp';
    import { usePlatformActions } from '@/libraries/composables/usePlatformActions';
    import { i18n } from '@/libraries/i18n';
    import { useAccountStore } from '@/stores/accountStore';

    const props = withDefaults(defineProps<{
        gaClassPrefix?: string;
    }>(), {
        gaClassPrefix: '',
    });

    const accountStore = useAccountStore();
    const { customerInfo } = storeToRefs(accountStore);
    const { updateAcceptAnyOdds } = accountStore;

    const acceptAnyOddsGaClass = computed(() => (
        props.gaClassPrefix === ''
            ? []
            : [
                `${props.gaClassPrefix}_Switch_AcceptAnyOdd_On`,
                `${props.gaClassPrefix}_Switch_AcceptAnyOdd_View`,
            ]
    ));

    const showAcceptAnyOddsTip = ref(false);

    let acceptAnyOddsTipTimeoutId: ReturnType<typeof setTimeout> | null = null;

    const { goToAcceptAnyOddsSettingsInApp } = useApp();
    const { handleActionByPlatform } = usePlatformActions();
    function handleClickAcceptAnyOddsTip() {
        handleActionByPlatform({
            appAction: () => goToAcceptAnyOddsSettingsInApp(),
            webAction: () => toggleAcceptAnyOddsTip(),
        });
    }

    function toggleAcceptAnyOddsTip() {
        showAcceptAnyOddsTip.value = !showAcceptAnyOddsTip.value;

        if (acceptAnyOddsTipTimeoutId !== null) {
            clearTimeout(acceptAnyOddsTipTimeoutId);
        }

        if (showAcceptAnyOddsTip.value) {
            acceptAnyOddsTipTimeoutId = setTimeout(() => {
                showAcceptAnyOddsTip.value = !showAcceptAnyOddsTip.value;
            }, 10000);
        }
    }

    async function toggleAcceptAnyOdds(newVal: boolean) {
        try {
            await updateAcceptAnyOdds(newVal);
        } catch (error) {
            console.error('Failed to update accept any odds:', error);
        }
    }

    onUnmounted(() => {
        if (acceptAnyOddsTipTimeoutId !== null) {
            clearTimeout(acceptAnyOddsTipTimeoutId);
        }
    });
</script>

<style lang="scss" scoped>
    @import "@/scss/components/acceptAnyOddsValue";
</style>
